import { GroupBase, MultiValueRemoveProps, SelectComponentsConfig, components as ReactSelectComponents } from 'react-select';
import IconClose from '@creditflowresearch/uilib/Icon/IconClose';

import styles from '../select.module.scss';

interface IProps<SOption, IsMulti extends boolean, Group extends GroupBase<SOption>> {
  isHasOneOption?: boolean,
  ownProps: MultiValueRemoveProps<SOption, IsMulti, Group>,
  components?: SelectComponentsConfig<SOption, IsMulti, Group>,
}

const MultiValueRemove = <SOption, IsMulti extends boolean, Group extends GroupBase<SOption>>({
  isHasOneOption = false,
  ownProps,
  components = {},
}: IProps<SOption, IsMulti, Group>) => {
  const value = ownProps.selectProps?.value;

  if (Array.isArray(value) && value.length === 1 && isHasOneOption) {
    return null;
  }

  if (components?.MultiValueRemove) {
    const { MultiValueRemove: MultiValueRemoveComponent } = components;

    return (
      <div className={ styles.multiValueRemoveIconWrapper }>
        <MultiValueRemoveComponent { ...ownProps } />
      </div>
    );
  }

  return (
    <ReactSelectComponents.MultiValueRemove { ...ownProps }>
      <IconClose className={ styles.multiValueRemoveIcon } />
    </ReactSelectComponents.MultiValueRemove>
  );
};

export default MultiValueRemove;
